import { axiosWrapper } from "../../../axios_old"
import { formatDate } from "../../../formating"
import { downloadData } from "../../../functions"
import URLSearchParamsExtended from "../../../URLSearchParams"
import APIWrapper, { axiosWrapperV2 } from "../../APIWrapper"

// Enums replaced with plain objects
export const CRON_TASK_CODE = {
	SUCCESS: 0,
	FAILED: 1,
	WARNING: 10
}

export const CRON_TASK_STATUS = {
	ACTIVE: "ACTIVE",
	DISABLED: "DISABLED",
	RUNNING: "RUNNING"
}

export const CRON_TASK_LEVEL = {
	SYSTEM: "SYSTEM",
	VALIDATION: "VALIDATION",
	INTEGRATION: "INTEGRATION",
	REPORT: "REPORT"
}

// Base CronTask class
export class CronTaskAttributes extends APIWrapper {
	constructor(attributes) {
		super(attributes)
		this.id = attributes.id
		this.name = attributes.name
		this.expression = attributes.expression
		this.description = attributes.description
		this.createdTs = attributes.createdTs
		this.token = attributes.token
		this.disabledTs = attributes.disabledTs
		this.lastTs = attributes.lastTs
		this.runCount = attributes.runCount
		this.level = attributes.level
		this.status = attributes.status
		this.links = attributes.links
	}
}

export class CronTask extends CronTaskAttributes {
	static async getAll() {
		const {
			data: { data: raw }
		} = await axiosWrapperV2.get({
			url: "cron"
		})
		return raw.map((r) => new this(r))
	}

	static async translateExpression(expression) {
		const { data } = await axiosWrapperV2.get({
			url: `cron?expression=${expression}`
		})
		return data
	}

	async invoke() {
		const { data } = await axiosWrapperV2.send(this.links.invoke)

		const str =
			typeof data.result === "string"
				? data.result
				: JSON.stringify(data.result, null, 2)

		downloadData({
			data: str,
			fileName: `${this.name}_executed_at_${new Date().toLocaleString()}.txt`,
			fileType: "text"
		})
	}

	async toggle() {
		return await axiosWrapperV2.send(this.links.toggle)
	}

	async changeExpression(expression) {
		if (this.links.changeExpression) {
			return await axiosWrapperV2.send({
				data: { expression },
				...this.links.changeExpression
			})
		}
	}
}

export class CronTaskLogAttributes extends APIWrapper {
	constructor(attributes) {
		super(attributes)
		this.id = attributes.id
		this.cronTaskId = attributes.cronTaskId
		this.result = attributes.result
		this.createdTs = attributes.createdTs
		this.token = attributes.token
		this.code = attributes.code
		this.time = attributes.time
	}
}

export class CronTaskLog extends CronTaskLogAttributes {
	static async getAll(params) {
		const {
			data: { data: raw, included }
		} = await axiosWrapperV2.send({
			method: "GET",
			url: `cron/log${params}&${new URLSearchParamsExtended({
				"attributes[exclude]": ["result"]
			}).toString()}`
		})

		const taskMap = new Map(included.tasks.map((user) => [user.id, user]))

		return raw.map(
			(r) =>
				new this({
					...r,
					task: taskMap.get(r.cronTaskId)
				})
		)
	}

	static async getOne(token, id) {
		const { data: log } = await axiosWrapper(
			"GET",
			`cron/log/${id}?${new URLSearchParamsExtended({
				"attributes[include]": ["result"]
			}).toString()}`,
			null,
			null,
			token
		)
		return new this(log)
	}

	constructor(attributes) {
		super(attributes)
		if (attributes.task) {
			this.task = new CronTask(attributes.task)
		}
	}

	get color() {
		switch (this.code) {
			case CRON_TASK_CODE.WARNING:
				return "warning"
			case CRON_TASK_CODE.FAILED:
				return "danger"
			default:
				return "success"
		}
	}

	get tableValues() {
		return {
			date: formatDate({
				data: this.createdTs,
				actions: ["display+time"]
			}),
			code: Object.keys(CRON_TASK_CODE).find(
				(k) => CRON_TASK_CODE[k] === this.code
			),
			duration: (this.time / 1000).toFixed(2) + "s"
		}
	}
}
